import {appendToast} from "../bootstrap";
import {wordings} from "../mixins/dictionaries";

const copy = ($toastContainer, textToCopy) => {
    if (textToCopy.length) {
        navigator.clipboard
            .writeText(textToCopy)
            .then(() => {
                appendToast($toastContainer, wordings["copied"], 0)
            })
    } else {
        appendToast($toastContainer, wordings["no_copy"], 1)
    }
}

const redo = ($container) => {
}
const undo = ($container) => {
}

export {
    copy,
    redo,
    undo
}